module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMCA2SDE2VjRDMTYgMi44OSAxNS4xMSAyIDE0IDJIMTBDOC44OSAyIDggMi44OSA4IDRWNkg0QzIuODkgNiAyLjAxIDYuODkgMi4wMSA4TDIgMTlDMiAyMC4xMSAyLjg5IDIxIDQgMjFIMjBDMjEuMTEgMjEgMjIgMjAuMTEgMjIgMTlWOEMyMiA2Ljg5IDIxLjExIDYgMjAgNlpNMTQgNkgxMFY0SDE0VjZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navbar/business.svg
// module id = 5hCg
// module chunks = 1